/* istanbul ignore file */
import { parsers } from '@codegrade/utils';
/**
 * The type of formatting used for the description of a rubric row or item.
 */
export const RubricDescriptionType = /* #__PURE__ */ parsers.exactly('plain_text', 'markdown');
